import { useAppDispatch, useAppSelector } from 'store/store-hooks';
import { handleFileConfig } from 'components/app/_mediator/app-files.slice';
import { BackupHandlers, BackupAction, BackupReq } from 'components/app/editor/_mediator/backup/backup.slice';
import {
  handleMarkers,
  handleClips,
  handleClipConfig,
  handleStoryConfig,
} from 'components/app/editor/_mediator/editor.slice';

export const useBackup = () => {
  const { backups, index } = useAppSelector((state) => state.backup);
  const dispatch = useAppDispatch();

  const getBackup = (action: BackupAction) => {
    if (action === 'undo') return backups[index - 1];
    return backups[index + 1];
  };

  const backupDispatchMap: {
    [K in BackupHandlers]: (payload: BackupReq<K>) => void;
  } = {
    [BackupHandlers.handleMarkers]: (payload) => dispatch(handleMarkers(payload)),
    [BackupHandlers.handleClips]: (payload) => dispatch(handleClips(payload)),
    [BackupHandlers.handleClipConfig]: (payload) => dispatch(handleClipConfig(payload)),
    [BackupHandlers.handleStoryConfig]: (payload) => dispatch(handleStoryConfig(payload)),
    [BackupHandlers.handleFileConfigs]: (payload) => dispatch(handleFileConfig(payload)),
  };

  return (action: BackupAction) => {
    const backup = getBackup(action);
    if (!backup) return;
    const handler = backupDispatchMap[backup.handler] as (payload: BackupReq<typeof backup.handler>) => void;
    handler({ data: backup.data, backupParams: backup.params, backupAction: action });
  };
};
